<template>
    <select class="form-control dropdown-bigger" v-bind:value="value"
            v-on:input="$emit('input', $event.target.value)">
        <option selected>Choose type</option>
        <option :key="type.id" :value="type.id" v-for="type in types">{{type.name}}</option>
    </select>
</template>
<script>
    export default {
        props: ['value'],
        data() {
            return {
                types: [
                    {
                        'id': 1,
                        'name': 'Normal'
                    },
                    {
                        'id': 2,
                        'name': 'Flame arrestor'
                    },
                ]
            }
        }
    }
</script>
<style>
    .dropdown-bigger {
        padding: .75rem;
    }
</style>
